import { Calendar, RotateCcw } from "lucide-react";

const BillingNote = () => {
  return (
    <section className="py-12 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto bg-muted/30 border-l-4 border-primary rounded-lg p-6 md:p-8">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
              <Calendar className="w-6 h-6 text-primary" />
            </div>
            <div className="flex-1 space-y-3">
              <h3 className="font-playfair text-xl font-semibold text-foreground">
                À l'issue de ton essai, facturation annuelle
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                La facturation se fait à l'année après l'essai. Tu peux résilier à tout moment, sans justification.
              </p>
              <div className="flex items-start gap-2 pt-2">
                <RotateCcw className="w-4 h-4 text-primary mt-1 flex-shrink-0" />
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Si tu pars en cours d'année, on te rembourse la part non utilisée au prorata.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BillingNote;
